import { render, staticRenderFns } from "./MyPolicyFloat.vue?vue&type=template&id=99cbc152&scoped=true&"
import script from "./MyPolicyFloat.vue?vue&type=script&lang=js&"
export * from "./MyPolicyFloat.vue?vue&type=script&lang=js&"
import style0 from "./MyPolicyFloat.vue?vue&type=style&index=0&id=99cbc152&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cbc152",
  null
  
)

export default component.exports